import React from "react";

// Text — for body copy, captions, labels (Manrope)
// Use Heading for display/section headings (Franie)
const sizes = {
  xs:  "text-[11px] font-normal leading-[1.5]",   // 11px — fine print, captions
  sm:  "text-[13px] font-normal leading-[1.55]",  // 13px — small labels
  md:  "text-[14px] font-normal leading-[1.6]",   // 14px — secondary body
  s:   "text-[15px] font-normal leading-[1.65]",  // 15px — primary body (was 20px)
  lg:  "text-[17px] font-normal leading-[1.6]",   // 17px — large body / callouts
};

const Text = ({ children, className = "", as, size = "s", ...restProps }) => {
  const Component = as || "p";

  return (
    <Component
      className={`text-white-A700_7f font-manrope ${sizes[size] ?? sizes["s"]} ${className}`}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export { Text };
